import Gif from "$components/editor/extensions/blocks/Gif/Gif.svelte";
import { Node, mergeAttributes } from "@tiptap/core";
import { Alignment, Size } from "$components/editor/extensions/blocks/shared/attributes";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export default Node.create({
  name: "gif",
  group: "block",
  draggable: true,
  atom: true,

  addAttributes() {
    return {
      gif: {
        default: null,
        parseHTML: (element) => JSON.parse(element.getAttribute("data-gif") || ""),
        renderHTML: (attributes) => {
          return {
            "data-gif": JSON.stringify(attributes.gif),
          };
        },
      },
      width: { default: Size.MEDIUM },
      align: { default: Alignment.LEFT },
    };
  },

  parseHTML() {
    return [
      {
        tag: "gifblock",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["gifblock", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Gif);
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const gif = node.attrs.gif;
          if (gif && gif.url) {
            state.write(`![GIF](${gif.url})\n\n`);
          } else {
            // if no valid GIF url, just add a new line to maintain spacing in doc
            state.write("\n");
          }
        },
      },
    };
  },
});
